import React from 'react';
import { useForm } from 'react-hook-form';
import employeeForm5 from '../../assets/images/employees/employeeform5.png';

const ProfessionalInfoForm = ({ onSubmit, data, enableValidation = false }) => {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm({
    defaultValues: data,
    mode: 'onSubmit'
  });

  const mergeWithExisting = (values) => ({
    ...(typeof data === 'object' && data !== null ? data : {}),
    ...values,
  });

  const getValidationRules = (field) => {
    if (!enableValidation) return {};

    const optionalPatternRule = (regex, message) => ({
      validate: (value) => {
        if (!value) return true;
        return regex.test(value) || message;
      }
    });

    const rules = {
      lastCompany: optionalPatternRule(/^[a-zA-Z0-9\s\-&.]+$/, 'Please enter a valid company name'),
      designation: optionalPatternRule(/^[a-zA-Z\s]+$/, 'Please enter a valid designation'),
      fromDate: {
        validate: {
          notFuture: (value) => {
            if (!value) return true;
            return new Date(value) <= new Date() || 'From date cannot be in the future';
          }
        }
      },
      toDate: {
        validate: {
          notBeforeFrom: (value, formValues) => {
            if (!value) return true;
            if (!formValues.fromDate) return true;
            return new Date(value) >= new Date(formValues.fromDate) || 'To date must be after from date';
          }
        }
      }
    };

    return rules[field] || {};
  };

  return (
    <form
      onSubmit={handleSubmit((formValues) => onSubmit({ professional: mergeWithExisting(formValues) }))}
      className="d-flex flex-column"
      style={{ minHeight: '80vh' }}
    >
      <div className="row flex-grow-1">
        <div className="col-md-8">
          <div className="row g-4">
            <div className="col-12">
              <div className="form-floating">
                <input
                  type="text"
                  className={`form-control ${errors.lastCompany ? 'is-invalid' : ''}`}
                  id="lastCompany"
                  placeholder="Enter Last Company"
                  {...register('lastCompany', getValidationRules('lastCompany'))}
                />
                <label htmlFor="lastCompany">Enter Last Company</label>
                {errors.lastCompany && <div className="invalid-feedback">{errors.lastCompany.message}</div>}
              </div>
            </div>

            <div className="col-12">
              <div className="form-floating">
                <input
                  type="text"
                  className={`form-control ${errors.designation ? 'is-invalid' : ''}`}
                  id="designation"
                  placeholder="Enter previous company designation"
                  {...register('designation', getValidationRules('designation'))}
                />
                <label htmlFor="designation">Previous Company Designation</label>
                {errors.designation && <div className="invalid-feedback">{errors.designation.message}</div>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-floating">
                <input
                  type="date"
                  className={`form-control ${errors.fromDate ? 'is-invalid' : ''}`}
                  id="fromDate"
                  placeholder="From Date"
                  {...register('fromDate', getValidationRules('fromDate'))}
                />
                <label htmlFor="fromDate">From Date</label>
                {errors.fromDate && <div className="invalid-feedback">{errors.fromDate.message}</div>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-floating">
                <input
                  type="date"
                  className={`form-control ${errors.toDate ? 'is-invalid' : ''}`}
                  id="toDate"
                  placeholder="To Date"
                  {...register('toDate', getValidationRules('toDate'))}
                />
                <label htmlFor="toDate">To Date</label>
                {errors.toDate && <div className="invalid-feedback">{errors.toDate.message}</div>}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="position-fixed end-0 d-none d-md-block" style={{ 
            maxWidth: '400px', 
            zIndex: 1, 
            bottom: '100px'
          }}>
            <img 
              src={employeeForm5} 
              alt="Professional Information" 
              className="img-fluid" 
              style={{ maxHeight: '45vh' }} 
            />
          </div>
        </div>
      </div>

      <div className="mt-auto pt-4 d-flex justify-content-between">
        <button
          type="button"
          onClick={() => onSubmit({ professional: mergeWithExisting(getValues()), goBack: true })}
          className="btn btn-outline-secondary px-4"
        >
          Back
        </button>
        <button type="submit" className="btn btn-danger px-4">
          Next
        </button>
      </div>
    </form>
  );
};

export default ProfessionalInfoForm;